import React, { useState, useMemo } from "react";
import { Form } from "react-bootstrap";
import "./GenerateBlogLeft.css";
import Select from "react-select";
import ISO6391 from "iso-639-1";
import AsyncSelect from "react-select/async";

const GenerateBlogLeft = ({
  about = "",
  tone = "",
  word_limit = "",
  location = null,
  language = null,
  further_details = "",
  onChange,
  onOptimize,
  brand_context = {},
  loadLocationOptions,
  onLocationChange,
  onTranslate,
  isTranslating = false
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState(language ? { label: language, value: language } : null);

  const languageOptions = useMemo(
    () => ISO6391.getAllNames().map(name => ({
      value: ISO6391.getCode(name),
      label: name
    })),
    []
  );

  // Custom handler for brand context fields
  const handleBrandContextChange = (fieldName, value) => {
    const newBrandContext = {
      ...brand_context,
      [fieldName]: value
    };
    // Call the parent's onChange with a custom event object
    onChange({
      target: {
        name: "brand_context",
        value: newBrandContext
      }
    });
  };

  // Handle language change
  const handleLanguageChange = (selectedOption) => {
    setSelectedLanguage(selectedOption);
    onChange({
      target: {
        name: "language",
        value: selectedOption?.label || ""
      }
    });
  };

  return (
    <div className="edit-product-left1">
      <h2 className="form-title">Please fill in your information</h2>

      <Form>
        <div className="mainform edit-product-left">
          <div className="form-section ">
            <label className="form-label">
              What is this blog about?{" "}
              <span className="required-asterisk">*</span>
            </label>
            <Form.Control
              as="textarea"
              name="about"
              value={about}
              onChange={onChange}
              required
              className="form-input"
              placeholder="Enter the main topic of your blog"
            />
          </div>
          <div className="form-section ">
            <label className="form-label">
              What should be the tone of voice? <span className="required-asterisk">*</span>
            </label>
            <input
              list="tone-options"
              name="tone"
              value={tone}
              onChange={onChange}
              required
              className="form-control form-input"
            />
            <datalist id="tone-options">
              <option value="Casual" />
              <option value="Professional" />
              <option value="Friendly" />
              <option value="Formal" />
              <option value="Informal" />
              <option value="Persuasive" />
            </datalist>
          </div>
          <div className="form-section ">
            <label className="form-label">
              How long do you want the blog to be?{" "}
              <span className="required-asterisk">*</span>
            </label>
            <input
              list="word-limit-options"
              name="word_limit"
              value={word_limit}
              onChange={onChange}
              required
              className="form-control form-input"
            />
            <datalist id="word-limit-options">
              <option value="Short (200-600 words)" />
              <option value="Medium (600-1200 words)" />
              <option value="Long (1200+ words)" />
            </datalist>
          </div>
          <div className="form-section">
            <label className="form-label">Location focus if any</label>
            <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={loadLocationOptions}
              value={location ? { label: location, value: location } : null}
              onChange={onLocationChange}
              isClearable
              isSearchable
              placeholder="Type to search location..."
              noOptionsMessage={({ inputValue }) =>
                !inputValue
                  ? "Type to search..."
                  : "No locations found for that query"
              }
              loadingMessage={() => "Searching locations..."}
              components={{
                DropdownIndicator: () => null, // Hide dropdown arrow
                IndicatorSeparator: () => null, // Hide separator
              }}
            />
          </div>
          <div className="form-section">
            <label className="form-label">Language</label>
            <Select
              options={languageOptions}
              value={selectedLanguage}
              onChange={handleLanguageChange}
              isClearable
              isSearchable
              placeholder="Select language..."
            />
          </div>
          <div className="form-section">
            <label className="form-label">
              Further details that you would like included here{" "}
              <span className="required-asterisk">*</span>
            </label>
            <Form.Control
              as="textarea"
              rows={1}
              placeholder="Add details about the product"
              className="form-textarea"
              name="further_details"
              value={further_details}
              onChange={onChange}
              required
            />
          </div>

          {/* Brand Context Section */}
          <div className="form-section">
            <label className="form-label">Brand Tone</label>
            <Form.Control
              as="textarea"
              rows={1}
              name="brand_tone"
              value={brand_context.brand_tone || ""}
              onChange={(e) =>
                handleBrandContextChange("brand_tone", e.target.value)
              }
              className="form-textarea"
              placeholder="Enter your brand tone"
            />
          </div>

          <div className="form-section">
            <label className="form-label">Brand Focus</label>
            <Form.Control
              as="textarea"
              rows={1}
              name="focus"
              value={brand_context.focus || ""}
              onChange={(e) =>
                handleBrandContextChange("focus", e.target.value)
              }
              className="form-textarea"
              placeholder="Enter your brand focus"
            />
          </div>

          <div className="form-section">
            <label className="form-label">Preferred Experts</label>
            <Form.Control
              as="textarea"
              rows={1}
              name="preferred_experts"
              value={brand_context.preferred_experts || ""}
              onChange={(e) =>
                handleBrandContextChange("preferred_experts", e.target.value)
              }
              className="form-textarea"
              placeholder="Enter preferred experts to quote"
            />
          </div>
        </div>

        <button
          type="button"
          className="optimize-button mt-2"
          onClick={onOptimize}
        >
          Optimize
        </button>
        <button
          type="button"
          className="optimize-button mt-2"
          onClick={onTranslate}
          disabled={isTranslating}
        >
          {isTranslating ? 'Translating...' : 'Translate'}
        </button>

        <button type="button" className="documents-button">
          Add additional documents
        </button>
      </Form>
    </div>
  );
};

export default GenerateBlogLeft;
